import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { OrganizationMipsSubmissionStatus } from '@models/mips-submission-block.model';

@Component({
  selector: 'app-mips-submission-actions-renderer',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  template: `
    <div class="actions-container">
      <button *ngIf="isBlocked" id="editBtn" data-action="edit" title="Edit Reasons">
        <mat-icon data-action="edit">edit</mat-icon>
      </button>
      <button id="toggleBtn" [attr.data-action]="isBlocked ? 'unblock' : 'block'">
        {{ isBlocked ? 'Unblock' : 'Block' }}
      </button>
    </div>
  `,
  styles: [`
    .actions-container {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      height: 100%;
    }
    #editBtn,
    #toggleBtn {
      cursor: pointer;
      border: none;
      border-radius: 4px;
      height: 26px;
      font-size: 12px;
      font-weight: 600;
      letter-spacing: 0.3px;
      line-height: 1;
    }
    #editBtn {
      background-color: #0099ab;
      color: white;
      width: 26px;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    #editBtn mat-icon {
      font-size: 16px;
      width: 16px;
      height: 16px;
      line-height: 16px;
    }
    #editBtn:hover {
      background-color: #007483;
    }
    #toggleBtn {
      background-color: #BF311A;
      color: white;
      padding: 0 14px;
    }
    #toggleBtn:hover {
      background-color: #a32a17;
    }
  `],
})
export class MipsSubmissionActionsRendererComponent implements ICellRendererAngularComp {
  isBlocked = false;

  agInit(params: ICellRendererParams): void {
    this.setState(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.setState(params);
    return true;
  }

  private setState(params: ICellRendererParams): void {
    const status = params.data as OrganizationMipsSubmissionStatus;
    this.isBlocked = status?.isBlocked ?? false;
  }
}
